import { RbacPrivilege } from 'types/api/rbac/rbac'
import { UserSession } from 'types/api/users/sessions/user-session'
import { isPrivateEdition } from 'utils/app-config'

export const TEAMS_WITH_SUPPORT_APP_ACCESS = new Set([
  '9060778c-be28-5052-ac55-762b5fe4fbfb', // Advocacy
  '8dde656c-505e-5bfa-958a-23fa70040acc', // Sales
  'be77f7cd-9272-5072-98d5-f03f402c96b3', // Security
  '51823ecb-9c44-526b-80d2-79b128559185', // Success
  '616d8e8d-46f0-5cfe-aa5e-f7b6fb0c4c6e', // Product
  '4b420303-d500-5d13-8e62-980348125226', // Management
  'dc878f18-4cbf-558a-b2e4-26ede3e92221', // Marketing
  'a8d2b852-21a9-50c1-adf5-de89a507e859', // Professional Services
  '5e07f9ed-cd53-5bee-96fb-3220ddc5318e', // Support
  'e7352a6b-a9a0-513c-81e4-980f680a70c2', // Engineering (Gremlin Inc.)
  'e7352a6b-a9a0-513c-82f4-980f680a1111' // Testing (cypress)
])

export const SUPPORT_APP_PRIVILEGES = [
  RbacPrivilege.ADMIN,
  RbacPrivilege.DEV,
  RbacPrivilege.MANAGE_BOOTCAMPS
]

/**
 * We enforce this check on the frontend because we don't want the support app
 * to be displayed in the UI if the user doesn't have access.
 */
export function hasSupportAppPermission(session: UserSession) {
  // user is a member of one of the teams with support app access
  const isAdminTeamMember = session?.teams?.some((team) =>
    TEAMS_WITH_SUPPORT_APP_ACCESS.has(team.identifier)
  )

  // user has support app viewing privileges
  const hasAdminRole = session?.privileges?.some((r) =>
    SUPPORT_APP_PRIVILEGES.includes(r)
  )

  return hasAdminRole && isAdminTeamMember && !isPrivateEdition()
}
